export enum EDiscountCodeType {
	FIXED = 'fixed',
	PERCENTAGE = 'percentage',
}

export enum EDiscountCodeAppType {
	MOBILE = 'mobile',
	WEB = 'web',
}
